import { Field, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import React from 'react';
import classNames from 'classnames/bind';
import styles from './EmbedCode.module.scss';
import compose from 'lib/enhancers/compose';
import withStyles from 'lib/enhancers/withStyles';

type EmbedCodeProps = ComponentProps & {
  fields: {
    embedCode: Field<string>;
  };
};

const cx = classNames.bind(styles);

const EmbedCode = (props: EmbedCodeProps): JSX.Element => {
  const { fields, className } = props;

  return (
    <div className={cx('embed-code', className)}>
      <div dangerouslySetInnerHTML={{ __html: fields.embedCode.value }} />
    </div>
  );
};

export default compose<EmbedCodeProps>(withDatasourceCheck(), withStyles())(EmbedCode);
